import React from 'react';
import {Stack, Typography} from '@mui/material';
import {IconSuccess} from '../../../components/IconSuccess/IconSuccess';
import {useTranslate} from '../../../hooks';
import type {VerifyContactFlow} from '../useVerifyContactFlow';

export const VerifyContactStepViewSuccess: React.FC<{
  flow: VerifyContactFlow;
}> = ({flow}) => {
  const {channel, displayValue} = flow;
  const translate = useTranslate();
  const titleKey =
    channel === 'email'
      ? 'verify-contact.success.email.title'
      : 'verify-contact.success.phone.title';
  return (
    <Stack alignItems={'center'} spacing={2} sx={{textAlign: 'center', py: 2}}>
      <IconSuccess />
      <Typography variant={'h3'}>{translate(titleKey)}</Typography>
      <Typography variant={'body2'} color={'text.secondary'}>
        {translate('verify-contact.success.description', {
          target: displayValue,
        })}
      </Typography>
    </Stack>
  );
};
